import { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import DOMPurify from 'dompurify';
import SEO from "../Components/SEO";
import TheNav from "../Components/navbar";

const ResetPassword = () => {
    const [formData, setFormData] = useState({
        email: ""
    });
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: sanitizedValue,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const auth = getAuth();
        sendPasswordResetEmail(auth, formData.email)
            .then(() => {
                setMessage("Check your inbox for further instructions");
            })
            .catch((error) => {
                setError("Failed to reset password. Make sure the email is correct.");
                console.error("Error resetting password:", error);
            });
    };
    return (
        <>
            <SEO
                title="Reset Password | Kre8"
                description="Reset your Kre8 Content account password."
                canonicalPath="/reset"
                noindex
            />

            <TheNav />
            <div className="mobile-safe relative flex min-h-screen items-center justify-center overflow-hidden bg-[#07060d] px-4 py-16 text-white">
                <div aria-hidden className="pointer-events-none absolute -left-24 top-24 h-80 w-80 rounded-full bg-[#9146FF]/18 blur-3xl" />
                <div aria-hidden className="pointer-events-none absolute -right-20 bottom-10 h-72 w-72 rounded-full bg-[#84ff00]/10 blur-3xl" />
                <div className="relative mx-auto w-full max-w-lg rounded-3xl border border-white/10 bg-white/[0.035] p-6 shadow-[0_30px_100px_-60px_rgba(132,255,0,0.65)] backdrop-blur-xl sm:p-8">
                 <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#84ff00]">Account Access</p>
                 <h1 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">Reset Password</h1>
                 <p className="mt-2 text-sm leading-6 text-zinc-400">Enter your email and we’ll send reset instructions for your Kre8 account.</p>

                 {error && <p className="mt-5 rounded-2xl border border-red-300/20 bg-red-500/10 px-4 py-3 text-sm text-red-100">{error}</p>}
                 {message && <p className="mt-5 rounded-2xl border border-lime-300/20 bg-lime-300/10 px-4 py-3 text-sm text-lime-100">{message}</p>}
                 <form className="mt-8" onSubmit={handleSubmit}>
                     <div className="flex flex-col space-y-5">
                        <label htmlFor="email">
                            <p className="pb-2 text-sm font-semibold text-zinc-300">Email address</p>
                            <input id="email" name="email" type="email" required
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3 text-sm text-white outline-none transition placeholder:text-zinc-500 focus:border-lime-300/40 focus:ring-2 focus:ring-lime-300/10" placeholder="you@example.com" />
                        </label>

                        <button value="Submit" className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[#84ff00] px-5 py-3.5 text-sm font-bold text-black transition hover:brightness-110">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
                            </svg>

                            <span>Reset password</span>
                        </button>
                        <p className="text-center text-sm text-zinc-500">Not registered yet? <a href="/signup" className="font-semibold text-[#84ff00] transition hover:text-white">Create an account</a></p>
                    </div>
                </form>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
